import { Theme, makeStyles, createStyles, Collapse, Container, Typography } from '@material-ui/core';
import React, { FC, useCallback, useState } from 'react';
import { FormControlProps, useLayoutNodeErrorCount } from '..';
import { TableDefinition, AlertDefinition } from '../services';
import { registry } from '../registry';
import { LayoutNodeWrapper } from './LayoutNode';
import { Color, Alert as MuiAlert } from '@material-ui/lab';
import { TemplatedText } from './TemplatedText';
import ExpandMoreOutlined from "@material-ui/icons/ExpandMoreOutlined";
import { ExpandLessOutlined } from '@material-ui/icons';

export interface AlertProps extends FormControlProps<AlertDefinition> {
  rowIndex?: number;
  header?: AlertDefinition;
  tableDefinition?: TableDefinition;
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    root(props: AlertProps) {
      return {
        flex: 1,
        width: '100%',
        marginBottom: theme.spacing(1),
        display: 'flex',
        backgroundColor: props.definition.style?.background ?? 'inherit'
      }
    },
    title(props: AlertProps) {
      return {
        display: 'flex',
        justifyContent: 'space-between',
      }
    },
    '.MuiAlert-message': {
      width: '100%'
    },
    collapseContainer: {
      padding: 0
    },
    collapseWrapper: {
      padding: 0
    },
    containerRoot: {
      padding: 0
    },
    alertRoot: {
      display: 'flex',
    },
    alertMessage: {
      flex: 1
    },
    titleRight: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center'
    },
    errorCount: {
      color: theme.palette.error.main,
      // position: 'absolute',
      // right: theme.spacing(2)
    }
  })
});

export const Alert: FC<AlertProps> = function(props) {
  const { definition, path } = props;
  const [ expanded, setExpanded ] = useState(false);
  const errors = useLayoutNodeErrorCount(path, definition);
  
  const classes = useStyles(props);
  const handleClick = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <MuiAlert severity={definition.severity as Color} classes={{
      root: classes.alertRoot,
      message: classes.alertMessage
    }}>
      <div className={classes.title} onClick={() => handleClick()}>
        <TemplatedText
          // className = { classes.text }
          template = {definition.template}
          params = {definition.params}>
        </TemplatedText>
        <div className={classes.titleRight}>
            {
            errors > 0 && <Typography variant = { 'caption' } className = { classes.errorCount }>
              { errors }
            </Typography>
          }
          {definition.children && (
            expanded ? <ExpandLessOutlined /> : <ExpandMoreOutlined />
          )}
        </div>
      </div>
      <Collapse in={expanded} classes={{
        container: classes.collapseContainer,
        wrapper: classes.collapseWrapper,
      }}>
        <Container classes={{
          root: classes.containerRoot
        }}>
          {
            (definition.children ?? []).map((cell, i) => {
              return <LayoutNodeWrapper
                    path = { path.concat('/children/') + i } key = { i }>
                  </LayoutNodeWrapper>;
            })
          }
        </Container>
      </Collapse>
    </MuiAlert>
  )
};

registry.registerComponent('Alert', Alert);
